import { mergeTemplateDesign, templateDesignToCssVars } from "../design";
import {
    SITE_BUILDER_INNER_BLOCK_TYPES,
    SITE_BUILDER_STRUCTURE_BLOCK_TYPES,
} from "../innerContentBlocks";
import type { SiteTemplateDefinition, SiteTemplateManifest, TemplateRenderProps } from "../types";
import { MorrowTemplateClient } from "./morrowClient";

const morrowInnerContentBlocks = [
    "richContent",
    ...SITE_BUILDER_STRUCTURE_BLOCK_TYPES,
    ...SITE_BUILDER_INNER_BLOCK_TYPES,
];

const morrowPageTypes: NonNullable<SiteTemplateManifest["pageTypes"]> = Object.fromEntries(
    ["home", "category", "section", "product", "cart", "checkout", "customerAccount", "contact", "search", "notFound"]
        .map((pageType) => (
            [pageType, {
                label: pageType,
                slots: morrowInnerContentBlocks,
                systemBlocks: [],
            }]
        )),
);

export const morrowTemplate: SiteTemplateDefinition = {
    manifest: {
        code: "morrow",
        name: "Morrow",
        type: "shop",
        category: "ecommerce",
        description: "Open Market is a warm, search-led storefront with original inner-content canvases and its own commerce experience.",
        previewImage: "/templates/morrow/preview.jpg",
        defaults: {
            colors: {
                primary: "#087F5B",
                accent: "#FFB36B",
                background: "#F6F2E9",
                surface: "#FFFFFF",
                text: "#15231F",
                muted: "#63706A",
                border: "#CED4CC",
            },
            typography: { heading: "Inter", body: "Inter" },
            layout: { container: "1360px", sectionSpacing: "comfortable", radius: "16px" },
            components: { header: "openMarket", footer: "openMarket", buttons: "solid", forms: "line", cartFlow: "singlePage" },
        },
        pageTypes: morrowPageTypes,
        editable: {
            colors: true,
            typography: true,
            radius: true,
            header: ["openMarket"],
            footer: ["openMarket"],
            buttons: ["solid", "outline"],
        },
    },
    render: (props: TemplateRenderProps) => {
        const design = mergeTemplateDesign(morrowTemplate.manifest.defaults, props.designOverride ?? props.site?.templateDesign);

        return (
            <div
                className="min-h-screen bg-[var(--site-background)] font-[var(--site-body-font)] text-[var(--site-text)] antialiased selection:bg-[var(--site-accent)] selection:text-[var(--site-on-accent)]"
                style={templateDesignToCssVars(design)}
            >
                <MorrowTemplateClient
                    siteName={props.site?.name ?? "Morrow"}
                    pages={props.pages}
                    page={props.page}
                    pageContext={props.pageContext}
                    shopBasicData={props.shopBasicData}
                    cartApiBasePath={props.cartApiBasePath}
                    customerApiBasePath={props.customerApiBasePath}
                    previewCustomerSession={props.previewCustomerSession}
                    onStorefrontLanguageSelect={props.onStorefrontLanguageSelect}
                    onStorefrontNavigate={props.onStorefrontNavigate}
                    storefrontLocationHref={props.storefrontLocationHref}
                    shopResolveApiPath={props.shopResolveApiPath}
                    shopSearchApiPath={props.shopSearchApiPath}
                    manufacturingProfileApiBasePath={props.manufacturingProfileApiBasePath}
                    packetaApiKey={props.packetaApiKey}
                    LinkComponent={props.LinkComponent}
                    design={design}
                    editorMode={props.editorMode ?? false}
                />
            </div>
        );
    },
};
